<template>
  <div class="homeAllModule" v-if="moduleData">
    <tab :moduleData="moduleData" :homeConfig="homeConfig" @tabClick="tabClick" >
      <div v-if="isAll" class="module">
        <template v-if="!isToday">
          <div class="module-content">
            <ul>
              <li class="title"></li>
              <li class="title">PK人数</li>
              <li class="title">PK局数</li>
            </ul>
            <ul>
              <li>PK模式</li>
              <li>{{ moduleData.pk_service_person_num | formatNumberFilter }}</li>
              <li>{{ moduleData.pk_person_count | formatNumberFilter }}</li>
            </ul>
            <ul v-if="typeof moduleData.quick_pk_count != 'undefined'">
              <li>快速PK</li>
              <li>{{ moduleData.quick_pk_person_num | formatNumberFilter }}</li>
              <li>{{ moduleData.quick_pk_count | formatNumberFilter }}</li>
            </ul>
            <ul v-else>
              <li>快速PK</li>
              <li>0</li>
              <li>0</li>
            </ul>
            <ul
              v-if="
                teamInfo.payStatus != 0
              "
            >
              <li>团队赛</li>
              <li>{{ moduleData.pk_service_team_num | formatNumberFilter }}</li>
              <li>{{ moduleData.pk_team_count < 0 ? 0 : moduleData.pk_team_count | formatNumberFilter }}</li>
            </ul>
            <!-- TODO 单人模式 -->
            <ul>
              <li>单人模式</li>
              <li>{{ moduleData.pk_service_single_num | formatNumberFilter }}</li>
              <li>{{ moduleData.pk_single_count | formatNumberFilter }}</li>
            </ul>
            <ul v-if="isGray">
              <li>过五关斩六将</li>
              <li>{{ moduleData.challenge_pk_num | formatNumberFilter }}</li>
              <li>{{ moduleData.challenge_pk_count | formatNumberFilter }}</li>
            </ul>
            <ul>
              <li>训练场</li>
              <li>
                {{ moduleData.pk_service_training_num | formatNumberFilter }}
              </li>
              <li>{{ moduleData.pk_training_count | formatNumberFilter }}</li>
            </ul>
          </div>
          <footer
            v-if="isOver && moduleData.promote_segment_num > 0"
            class="footerBg"
            :style="{ backgroundColor: homeConfig.levelUpBgColor }"
          >
            <!-- 只有结束 并且>0才显示-->
            <img :src="homeConfig.levelUpIcon" />
            <span
              >提升段位人数：<label
                >{{
                  moduleData.promote_segment_num | formatNumberFilter
                }}人</label
              ></span
            >
            <router-link
              :to="{
                name: 'honorRoll',
                params: {
                  scheduleId: teamInfo.scheduleId || '',
                  seasonId: teamInfo.seasonId || '',
                },
              }"
              :style="{ color: homeConfig.levelUpTextColor }"
              >查看></router-link
            >
          </footer>
        </template>
        <template v-else>
          <ul>
            <li class="title"></li>
            <li class="title">PK人数</li>
            <li class="title">PK局数</li>
          </ul>
          <ul>
            <li>PK模式</li>
            <li>{{ moduleData.pk_service_person_num | formatNumberFilter }}</li>
            <li>{{ moduleData.pk_person_count | formatNumberFilter }}</li>
          </ul>
          <ul v-if="typeof moduleData.quick_pk_count != 'undefined'">
            <li>快速PK</li>
            <li>{{ moduleData.quick_pk_person_num | formatNumberFilter }}</li>
            <li>{{ moduleData.quick_pk_count | formatNumberFilter }}</li>
          </ul>
          <ul v-else>
            <li>快速PK</li>
            <li>0</li>
            <li>0</li>
          </ul>
          <ul
            v-if="
              teamInfo.payStatus != 0
            "
          >
            <li>团队赛</li>
            <li>{{ moduleData.pk_service_team_num | formatNumberFilter }}</li>
            <li>{{ moduleData.pk_team_count < 0 ? 0 : moduleData.pk_team_count | formatNumberFilter }}</li>
          </ul>
          <!-- TODO 单人模式 -->
          <ul>
            <li>单人模式</li>
            <li>{{ moduleData.pk_service_single_num | formatNumberFilter }}</li>
            <li>{{ moduleData.pk_single_count | formatNumberFilter }}</li>
          </ul>
          <ul v-if="isGray">
            <li>过五关斩六将</li>
            <li>{{ moduleData.challenge_pk_num | formatNumberFilter }}</li>
            <li>{{ moduleData.challenge_pk_count | formatNumberFilter }}</li>
          </ul>
          <ul>
            <li>训练场</li>
            <li>
              {{ moduleData.pk_service_training_num | formatNumberFilter }}
            </li>
            <li>{{ moduleData.pk_training_count | formatNumberFilter }}</li>
          </ul>
        </template>
      </div>
      <div v-else class="team">
        <h3 :class="[teamInfo.teamId > 0 ? '' : 'noTeam']">
          <template v-if="teamInfo.teamId > 0">
            {{ teamInfo.teamName }}
          </template>
          <template v-else> 还未组建战队，快去组建吧~ </template>
        </h3>
        <main :class="[cssClass]">
          <template v-if="teamInfo.payStatus == 1">
            <!-- 如果报名了-->
            <template v-if="teamInfo.teamId > 0">
              <!-- 如果组建战队了-->
              <template v-if="moduleData.pk_team_count !== -1">
                <!--  "pk_team_count": -1,//团队赛局数  -1当日无团队赛-->
                <template v-if="isOver">
                  <!-- 昨日战绩(战队）-->
                  <div class="race raceOver">
                    <div>
                      <dl>
                        <dt>
                          {{
                            moduleData.pk_settled_team_count
                              | formatNumberFilter
                          }}
                        </dt>
                        <dd>PK局数</dd>
                      </dl>

                      <dl>
                        <dt>
                          {{
                            moduleData.settled_team_win_count
                              | formatNumberFilter
                          }}
                        </dt>
                        <dd>胜利局数</dd>
                      </dl>
                    </div>
                    <div>
                      <dl>
                        <dt>
                          {{
                            moduleData.pk_settled_team_score
                              | formatNumberFilter
                          }}
                        </dt>
                        <dd>奖杯数</dd>
                      </dl>
                      <dl>
                        <dt>
                          {{
                            moduleData.pk_settled_team_count > 0
                              ? Math.round(
                                  moduleData.pk_settled_team_score /
                                    moduleData.pk_settled_team_count
                                )
                              : 0 | formatNumberFilter
                          }}
                        </dt>
                        <dd>局均奖杯数</dd>
                      </dl>
                    </div>
                    <img
                      v-if="moduleData.pk_status == 1 && show"
                      class="seal"
                      src="../../../assets/images/winterGame/win_seal.png"
                    />

                    <footer>
                      <share-btn
                        @shareClick="shareClick"
                        title="查看海报"
                        :btnColor="homeConfig.rewardBtnColor"
                      ></share-btn>
                    </footer>
                  </div>
                </template>
                <template v-else>
                  <div class="race">
                    <div>
                      <dl>
                        <dt>
                          {{ moduleData.pk_team_num | formatNumberFilter }}
                          <span v-if="moduleData.no_battle_pk_team_num > 0"
                            >{{ moduleData.no_battle_pk_team_num }}人未PK</span
                          >
                        </dt>
                        <dd>PK人数</dd>
                      </dl>

                      <dl>
                        <dt>
                          {{
                            moduleData.settled_team_win_count
                              | formatNumberFilter
                          }}/{{
                            moduleData.settled_team_fail_count
                              | formatNumberFilter
                          }}/{{
                            moduleData.settled_team_flat_count
                              | formatNumberFilter
                          }}/{{
                            moduleData.settled_team_empty_count
                              | formatNumberFilter
                          }}
                        </dt>
                        <dd>胜/负/平/空</dd>
                      </dl>
                    </div>
                    <div>
                      <dl>
                        <dt>
                          {{
                            moduleData.pk_settled_team_count
                              | formatNumberFilter
                          }}/{{
                            moduleData.pk_no_settled_team_count
                              | formatNumberFilter
                          }}
                        </dt>
                        <dd>
                          已结算/未结算
                          <p>PK局数</p>
                        </dd>
                      </dl>

                      <dl>
                        <dt>
                          {{
                            moduleData.pk_settled_team_score
                              | formatNumberFilter
                          }}
                        </dt>
                        <dd>
                          已结算
                          <p>奖杯数</p>
                        </dd>
                      </dl>
                    </div>
                  </div>
                </template>
              </template>
              <template v-else>
                <div class="noRace">
                  <img src="../../../assets/images/winterGame/noRace.png" />
                  <p v-if="teamInfo.warStatus == 1">无比赛</p>
                  <p v-else @click="addTeamMembers">请尽快提交出战名单<van-icon name="arrow" /></p>
                </div>
              </template>
            </template>
            <template v-else>
              <div class="noCreate">
                <span @click="toMyTeam">去组建</span>
              </div>
            </template>
          </template>
          <template v-else>
            <div v-if="teamInfo.teamId > 0" class="noSignUp">
              您的战队未报名{{ teamInfo.cupName.replace("松鼠杯", "") }}
            </div>
            <template v-else>
              <div class="noCreate">
                <span @click="toMyTeam">去组建</span>
              </div>
            </template>
          </template>
        </main>
      </div>
    </tab>
  </div>
</template>

<script>
import Tab from "@views/WinterGame/components/tab.vue";
import ShareBtn from "@views/WinterGame/components/shareBtn.vue";
import { Toast, Dialog } from "vant";
import {
  checkAgentMatchSign
} from "../../../api/winterGame";

export default {
  name: "homeAllModule",
  components: { ShareBtn, Tab },
  computed: {
    cssClass() {
      const status = 1;
      let cssClass = "status_" + status;
      return cssClass;
    },
    title() {
      let title = "学霸们四处冲冲冲";
      return title;
    },
  },
  props: {
    season: {
      type: String,
      default: "",
    },
    isOver: {
      type: Boolean,
      default: false,
    },
    moduleData: {
      type: Object,
      default: null,
    },
    teamInfo: {
      type: Object,
      default: null,
    },
    gameType: {
      type: Number,
      default: 0,
    },
    isToday: {
      type: Boolean,
      default: false,
    },
    isGray: {
      type: Boolean,
      default: false,
    },
    schedule_tag_id: {
      type: String,
      default: "",
    },
    homeConfig:{
      type:Object,
      default:()=>{}
    }
  },
  data() {
    return {
      isAll: true,
      show: true,
      upImg: "",
    };
  },
  watch: {
    season(newValues, oldValues) {
      this.upImg = require("../../../assets/images/winterGame/up_arr.png");
    },
    gameType(newVal, oldVal) {
      if (newVal == 1) {
        this.show = false;
      } else {
        this.show = true;
      }
    },
  },
  methods: {
    addTeamMembers() {
      if (this.teamInfo.teamId == 0) {
        Toast("战队未建设");
      } else {
        this.checkAgentMatchSign();
      }
    },
    async checkAgentMatchSign() {
      const { currentCampusId, seasonId } = JSON.parse(localStorage.getItem("pkParams")) || {}
      let params = {
        param: {
          currentCampusId: currentCampusId,
          seasonId: seasonId,
          openId: "",
        },
      };
      let res = await checkAgentMatchSign(params);
      if (res.code == 0) {
        this.toMembers();
      } else {
        this.$toast(res.message);
      }
    },
    toMembers() {
      if (this.teamInfo.teamMemberStatus == 0) {
        Dialog.confirm({
          title: "错误",
          confirmButtonText: "去添加",
          message: "暂无战队成员，请先添加战队成员",
        }).then(() => {
            wx.miniProgram.navigateTo({
              url: `/subpackages/home/winterGame/myTeamMembers/index?scheduleId=${this.schedule_tag_id}`,
            });
          }).catch(() => {
          });
      } else {
        wx.miniProgram.navigateTo({
          url: `/subpackages/home/winterGame/addTeamMembers/index?teamId=${this.teamInfo.teamId}&scheduleId=${this.schedule_tag_id}`,
        });
      }
    },
    getFooterBgClass(season) {
      let footerBgClass = 'footerBg';
      return footerBgClass;
    },
    init() {
      this.upImg = require("../../../assets/images/winterGame/up_arr.png");
    },
    shareClick() {
      this.$emit("shareClick", { isWin: this.moduleData.pk_status == 1 });
    },
    toMyTeam() {
      this.$router.push("/winterGame/main");
    },
    tabClick({ isAll }) {
      this.isAll = isAll;
      this.$emit("tabClick", { isAll });
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="less" scoped>
.homeAllModule {
  display: flex;
  justify-content: center;
  flex-direction: column;
  .module {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px 0px;
    hr {
      width: 414px;
      height: 2px;
      background: #dee5f0;
      border: 0;
      margin-top: 16px;
      margin-bottom: 22px;
    }
    p {
      height: 40px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #68707d;
      line-height: 40px;
      margin: 0 auto;
    }
    dl {
      margin: 0 16px;
      display: flex;
      text-align: center;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      dt {
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #68707d;
        line-height: 40px;
        margin-bottom: 16px;
      }

      dd {
        margin-left: 0;
        width: 58px;
        height: 66px;
        font-size: 48px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #323232;
        line-height: 66px;
      }
    }
    .module-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 40px;
    }
    ul {
      width: 100%;
      display: flex;
      list-style: none;
      justify-content: center;
      align-items: center;
      height: 110px;
      // border-bottom: 1px solid #dee5f0;
      background-color: transparent;
      padding: 0;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        left: 50%; //居中
        transform: translateX(-50%);
        bottom: 0;
        width: 80%;
        height: 1px;
        background-color: #dee5f0;
      }
      &:first-child {
        &::after {
          height: 0;
        }
        height: 50px;
        .title {
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #68707d;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      &:last-child {
        height: 90px;
        &::after {
          height: 0;
        }
      }
      li:first-child {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #68707d;
        // justify-content: start;
      }
      li:nth-child(2) {
        font-size: 48px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #323232;
      }
      li:nth-child(3) {
        font-size: 48px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #323232;
      }
      li {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #ffffff;
        white-space: nowrap;
      }
    }
    div {
      display: flex;
      width: 100%;
      justify-content: space-around;

      dl {
        display: flex;
        flex-direction: column-reverse;
        dd {
          margin-bottom: 16px;
          margin-bottom: 0;
        }
      }
    }
    footer {
      margin-top: 32px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 96px;
      background: #e4f1fd;
      img {
        width: 48px;
      }
      span {
        display: flex;
        align-items: center;
        height: 44px;
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #323232;
        line-height: 44px;
        margin-left: 16px;
        margin-right: 46px;
        label {
          height: 66px;
          font-size: 48px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #323232;
          line-height: 66px;
        }
      }
      a {
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #58abf6;
        line-height: 40px;
        position: relative;
      }
    }
    .footerBg {
      background: #e4f1fd;
      a {
        color: #58abf6;
      }
    }
    .footerAutumnBg {
      background: #FFF6D7;
      a {
        color: #CE580A;
      }
    }
  }
  .team {
    padding: 56px;
    h3 {
      font-size: 40px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #323232;
      line-height: 56px;
      margin: 0 auto;
      text-align: center;
      position: relative;
      top: -30px;
      &.noTeam {
        top: 0px;
      }
    }
    main {
      div {
        &.race {
          position: relative;
          div {
            display: flex;
            justify-content: center;

            &:first-child {
              border-bottom: 2px solid #dee5f0;

              dl {
                dd {
                  padding-bottom: 24px;
                }

                &:first-child {
                  dt {
                    position: relative;

                    span {
                      position: absolute;
                      top: -20px;
                      width: 98px;
                      height: 42px;
                      background: url("../../../assets/images/tip.png")
                        no-repeat;
                      font-size: 18px;
                      font-family: PingFangSC-Regular, PingFang SC;
                      font-weight: 400;
                      color: #ffffff;
                      line-height: 40px;
                      background-size: cover;
                    }
                  }

                  dd {
                    border-right: 2px solid #dee5f0;
                  }
                }
              }
            }

            &:nth-child(2) {
              dl {
                dt {
                  padding-top: 24px;
                }

                &:first-child {
                  dt {
                    border-right: 2px solid #dee5f0;
                  }
                }
              }
            }

            dl {
              width: 50%;
              flex-grow: 1;
              margin: 0;
              text-align: center;

              dt {
                padding-bottom: 8px;
                font-size: 48px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #323232;
                line-height: 66px;
              }

              dd {
                margin-left: 0;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #68707d;
                line-height: 40px;

                p {
                  margin: 2px 0 0 0;
                }
              }
            }
          }
          footer {
            margin-top: 40px;
          }
          img {
            &.seal {
              width: 188px;
              position: absolute;
              top: -80px;
              right: -100px;
            }
          }
        }

        &.noRace {
          text-align: center;
          margin-top: 56px;
          img {
            width: 122px;
            margin-bottom: 18px;
          }
          p {
            margin: 0;
            height: 40px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #68707d;
            line-height: 40px;
          }
        }
        &.noCreate {
          width: 312px;

          height: 64px;
          background: #58abf6;
          border-radius: 32px;
          border: 2px solid #58abf6;
          line-height: 64px;
          color: #ffffff;
          text-align: center;
          margin: 90px auto auto;
        }
        &.noSignUp {
          margin-top: 24px;
          text-align: center;
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #68707d;
          line-height: 40px;
        }
      }
    }
  }
}
</style>

<style lang="less">
.spring_2024 {
  .footerBg {
    background: #FAF6DD!important;
    a {
      color: #44872A!important;
    }
  }
}
.summer_2024 {
  .footerBg {
    background: #E4FBFD!important;
    a {
      color: #06B3CF!important;
    }
  }
}
.winter_2025 {
  .footerBg {
    background: #F7F1FF!important;
    a {
      color: #5B7AFF!important;
    }
  }
}
.spring_2025 {
  .footerBg {
    background: #F8FFE8!important;
    a {
      color: #45A428!important;
    }
  }
}
.summer_2025 {
  .footerBg {
    background: #E4FBFD!important;
    a {
      color: #06B3CF!important;
    }
  }
}
</style>
